import { CountryEnum } from 'common/enums';

export const CountryList = [
  { value: CountryEnum.US, label: 'United States' },
  { value: CountryEnum.Canada, label: 'Canada' }
]
